var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1990_12638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 20C36.6667 17.8113 36.2356 15.6441 35.398 13.622C34.5604 11.5999 33.3328 9.76257 31.7851 8.21493C30.2375 6.66728 28.4002 5.43963 26.3781 4.60205C24.356 3.76447 22.1887 3.33337 20 3.33337C15.5797 3.33337 11.3405 5.08932 8.2149 8.21493C5.08929 11.3405 3.33334 15.5798 3.33334 20C3.33334 24.4203 5.08929 28.6595 8.2149 31.7852C11.3405 34.9108 15.5797 36.6667 20 36.6667C24.4203 36.6667 28.6595 34.9108 31.7851 31.7852C34.9107 28.6595 36.6667 24.4203 36.6667 20ZM33.2167 18.3334H28.3333C28.0585 14.4136 26.7155 10.644 24.45 7.43337C26.7775 8.25999 28.8296 9.71682 30.3775 11.6414C31.9254 13.5661 32.9084 15.8828 33.2167 18.3334ZM15.1333 21.6667H25C24.5735 25.7843 22.8184 29.6513 20 32.6834C17.1835 29.664 15.4687 25.7822 15.1333 21.6667ZM15.1333 18.3334C15.5215 14.2364 17.2293 10.3762 20 7.33337C22.8412 10.3436 24.6002 14.2134 25 18.3334H15.1333ZM15.7333 7.38337C13.4559 10.6117 12.0913 14.3946 11.7833 18.3334H6.78334C7.09818 15.8525 8.10436 13.5102 9.68695 11.574C11.2696 9.63775 13.3648 8.18559 15.7333 7.38337ZM6.78334 21.6667H11.7833C12.0578 25.6022 13.4131 29.3855 15.7 32.6C13.34 31.7939 11.2533 30.342 9.67712 28.4093C8.10093 26.4767 7.09837 24.1407 6.78334 21.6667ZM24.3667 32.5834C26.6474 29.3678 28.0178 25.5963 28.3333 21.6667H33.25C32.9348 24.1338 31.9359 26.4635 30.3661 28.3926C28.7963 30.3218 26.7182 31.7733 24.3667 32.5834Z",
    fill: "url(#paint0_linear_1990_12638)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1990_12638",
    x1: -16.3506,
    y1: 6.41091,
    x2: 156.307,
    y2: 128.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1990_12638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/internet.c9c889d4e1dff17ecb22dfb0fd685245.svg";
export { ForwardRef as ReactComponent };